import { CognitoUserPool } from 'amazon-cognito-identity-js';
const poolData = {
  UserPoolId: 'ap-south-1_JrpuUw2sR',
 // ClientId: 'jim6g9kes6fhc7j7fik4hu562',
 // clientSecret:'b4vhdbh4u8e97hhtp7kmq10va91b9pptrqmlvro335idmp1dalr',
 ClientId : '6k79qvqm89g8e5mm4nnc38t472',
 //clientSecret ='19n65vvcs6nhm0a6lno3sep2umvfnmkqq0481gtd9dcs7oofcid7';
};
export default new CognitoUserPool(poolData);